import { Environment } from '../interfaces/environment.interface';

export const environment: Environment = {
  name: 'development',
  // api
  poolApi: 'https://stage-pool-api.wemine.tech/api',
  mmsApi: 'https://stage.wemine.tech/api',

  // domains
  techDomain: 'https://new-stage.wemine.tech',
  techMmsDomain: 'https://new-stage-mms.wemine.tech',
  techPoolDomain: 'https://new-stage-pool.wemine.tech',
  adminDomain: 'https://new-stage-admin.wemine.tech',

  // langs
  langs: ['en', 'ru'],
  defaultLang: 'en',

  // translate api
  translationApiUrl: 'https://translations-api.ataix.com/api',

  // sockets
  mmsSocket: 'wss://stage-socket.wemine.tech',

  // telegram bot
  poolTelegramBotUrl: 'https://t.me/wm_pool_stage_bot',
  mmsTelegramBotUrl: 'https://t.me/weminetech_stage_bot',

  // cookie key
  cookieKey: 'wm-tech-stage',
  adminCookieKey: 'wm-admin-stage',
};
